module.exports = __webpack_public_path__ + "static/media/undraw_interview_rmcf.c3afac0d.svg";